module.exports = __webpack_public_path__ + "img/wishlist-1.da53402.webp";